import { render, staticRenderFns } from "./DialogEditValorBase.vue?vue&type=template&id=3580cd03"
import script from "./DialogEditValorBase.vue?vue&type=script&lang=js"
export * from "./DialogEditValorBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports